import React from 'react';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { P3 } from '../Typo';

const Component = styled(NavLink)`
  position: relative;
  ${P3} {
    color: ${(props) => props.theme.colors.purple3};
  }

  &.active {
    ${P3} {
      color: white;
    }

    background-color: ${(props) => props.theme.colors.purple4};
    ::before {
      content: '';
      position: absolute;
      height: 100%;
      width: 4px;
      background-color: ${(props) => props.theme.colors.orange5};
      left: 0px;
      top: 0px;
    }
  }
  :hover {
    ${P3} {
      color: white;
    }
  }
`;

interface DefaultNavLinkProps {
  to: string;
  title: string;
  exact?: boolean;
  children?: React.ReactNode;
}

const DefaultNavLink = ({
  to,
  title,
  exact,
  children,
}: DefaultNavLinkProps) => {
  return (
    <Component exact={exact !== undefined ? exact : true} to={to}>
      {children}
      <P3>{title}</P3>
    </Component>
  );
};

export default DefaultNavLink;
